import axios from 'axios';
import router from "@/router";

const engineRequest = axios.create({
    baseURL: process.env.VUE_APP_ENGINE_BASEURL,   // 后端的接口地址 ip:port
    timeout: 6000000,                         // 600s 请求超时
    withCredentials: true
});

axios.defaults.withCredentials = true;


// request 拦截器
engineRequest.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=utf-8'; // 设置请求头格式
    return config;
}, error => {
    console.error('request error: ' + error); // for debug
    return Promise.reject(error);
});

// response 拦截器
engineRequest.interceptors.response.use(
    response => {
        let res = response.data;
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res;
        }
        if (res.code === '4001') {
            router.push('/login');
        }
        return res;
    },
    error => {
        console.error('response error: ' + error); // for debug
        return Promise.reject(error);
    }
);

export default engineRequest;
